import { LoginResult } from '@genesislcap/foundation-comms';
import { PROFILE_RIGHTS, getKeyByValue, PRODUCT_TYPE } from './enums/generic.enum';

export enum Profile {
  READ_ONLY_BUYER = 'READ_ONLY_BUYER',
  TRANSACTION_ADVISOR = 'TRANSACTION_ADVISOR',
  CASCADE_ADMIN = 'CASCADE_ADMIN',
  COMPANY_ADMIN = 'COMPANY_ADMIN',
  BUYER_COMPANY_ADMIN = 'BUYER_COMPANY_ADMIN',
  SELLER_COMPANY_ADMIN = 'SELLER_COMPANY_ADMIN',
  BI_DIRECTIONAL_COMPANY_ADMIN = 'BI_DIRECTIONAL_COMPANY_ADMIN',
  ADVISOR_COMPANY_ADMIN = 'ADVISOR_COMPANY_ADMIN',
  ADVISOR_AGENT = 'ADVISOR_AGENT',
  USER_ADMIN = 'USER_ADMIN'
}

export function hasOnlyTransactionAdvisor(loggedUserResult: LoginResult): boolean {
  return hasOnlyThisProfile(loggedUserResult, Profile.TRANSACTION_ADVISOR);
}

export function hasLegalOrAuthorizedSignatoryVisibility(permissionList: string[]): boolean {
  return (
    permissionList.includes(PROFILE_RIGHTS.LEGAL_VISIBILITY) ||
    permissionList.includes(PROFILE_RIGHTS.AUTHORIZED_SIGNATORY_VISIBILITY)
  );
}

export function hasOnlyThisProfile(loggedUserResult: LoginResult, profile: Profile) {
  return loggedUserResult.profiles?.filter((p) => getKeyByValue(p, Profile) != profile).length == 0;
}

export function hasPermission(permissions: string[], permissionToBeChecked: string): boolean {
  if (!permissions || permissions.length === 0) {
    return false;
  }

  return permissions.find((permission) => permission === permissionToBeChecked) ? true : false;
}

export function checkIfContainsAtLeastOneProfile(
  profiles: string[],
  profilesToCheck: Profile[],
): boolean {
  return profiles.some((profile) =>
    profilesToCheck.includes(getKeyByValue(profile, Profile)),
  );
}

export function updateProductTypeCriteriaByNonSEFParticipant(
  criteria: string,
  prefix?: string,
): string {
  let criteriaUpdated = criteria;
  if (criteriaUpdated !== null && criteriaUpdated !== '') {
    criteriaUpdated = criteriaUpdated.concat(` && `);
  }
  if (prefix) {
    criteriaUpdated = criteriaUpdated.concat(`${prefix}`);
  }
  criteriaUpdated = criteriaUpdated.concat(`PRODUCT_TYPE != '${PRODUCT_TYPE.VIRTUAL_PPA}'`);
  return criteriaUpdated;
}
